import React from 'react';
import logo from '../../img/algolia.png';
export const PoweredBy = () => (
  <span style={{ fontSize: '0.6em', textAlign: 'end', padding: 0 }}>
    Powered by{` `}
    <a href="https://algolia.com">
      <img src={logo} alt="Algolia" />
    </a>
  </span>
);
